import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SEO } from "../components/SEO";
import PageHero from "../components/PageHero";
import { Reveal } from "../components/Motion";
import { SERVICES } from "../data/services";

const ServicesHub = () => (
  <main data-testid="services-hub-page">
    <SEO
      title="Welding Repair Services in Fort Worth, TX | Aledo Welding"
      description="Repair-first mobile welding: gates & fences, trailers, heavy equipment, 24/7 emergency, structural, pipe, maintenance programs, and fabrication. Serving Fort Worth & Tarrant/Parker County."
    />
    <PageHero
      kicker="Repair-first · Mobile · On-site"
      title="Every welding repair we handle — at your place, not ours"
      lede="Eight services, one priority order: repair first, replacement only when repair genuinely isn't the right call. Every job starts with photos and ends with a written price honored."
      testidPrefix="services-hub"
    />
    <section className="bg-paper pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 grid sm:grid-cols-2 gap-px bg-warmline border border-warmline" data-testid="services-hub-grid">
        {SERVICES.map((s, i) => (
          <Reveal key={s.slug} delay={(i % 2) * 0.07}>
            <Link to={`/services/${s.slug}`} data-testid={`hub-service-${s.slug}`} className="group flex gap-6 bg-cream hover:bg-sand transition-colors duration-200 p-7 sm:p-9 h-full">
              <span className="font-display font-black text-4xl text-ink/10 group-hover:text-rust/30 transition-colors shrink-0">{String(i + 1).padStart(2, "0")}</span>
              <span>
                <span className="block font-mono text-xs uppercase tracking-[0.2em] text-steel font-semibold mb-2">{s.audience}</span>
                <span className="block font-display font-extrabold text-2xl tracking-tight group-hover:text-rust transition-colors">{s.name}</span>
                <span className="block mt-3 text-smoke leading-relaxed">{s.blurb}</span>
                <span className="mt-4 inline-flex items-center gap-2 text-sm font-bold text-rust">
                  Details <ArrowRight size={16} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden />
                </span>
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  </main>
);

export default ServicesHub;
